import { ErrorBox } from "@/modules/error/ErrorBox.tsx";
import { getAuth0CallbackParams } from "@/modules/login/auth0/auth0Callback.ts";
import { Auth0Callback } from "@/modules/login/auth0/Auth0Login.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/auth0_callback")({
    component: Auth0CallbackRoute,
});

function Auth0CallbackRoute() {
    const params = getAuth0CallbackParams();
    if (!params) {
        return (
            <ErrorBox>
                <p>No Auth0 callback params found</p>
            </ErrorBox>
        );
    }

    return <Auth0Callback params={params} />;
}
